
 import { controls } from "../controls";


const showsamenamesearch = {
    label: "Show Same name",
    pageLabel: "Show Same name",
    starting: true,
    url: "showsamenamesearch",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    filter:[
      ...controls.displayText({tab:"filter",name:'first_name',label: "Name",width:"col-sm-2"}),
    ...controls.text({tab: "filter",name:"name"})
    ],
    form:[],
    history: {
      perPage: 10,
      reportHeader: "Same name",
      pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
      displayColumns: [
        {
          Header: "CIN",
          accessor: "cin",
          width: 150
        },
        {
          Header: "Name",
          accessor: "text",
          width: 150
        },
        {
          Header: "Pan",
          accessor: "pan"
        },
        {
          Header: "AAdhar UID",
          accessor: "addhar"
        },
        {
          Header: "Addr1",
          accessor: "ref"
        }
      ]
    }
  };
  
  export default showsamenamesearch;
  